import { render, staticRenderFns } from "./Rating.vue?vue&type=template&id=2b9dd20e&lang=pug"
import script from "./Rating.vue?vue&type=script&lang=js"
export * from "./Rating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports